/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AssistantAndProvider/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Assistant from './Assistant/index'
import Provider from './Provider/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AssistantAndProvider({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/AppointmentCell/AssistantAndProvider"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="AssistantAndProvider.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Provider
  viewPath={`${viewPath}/Provider`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="/"
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral700}
/>
<Assistant
  viewPath={`${viewPath}/Assistant`}
/>
</div>
{children}
</React.Fragment>)
}